export default (apiFetch) => async ({ page = 1, exclude = [], size = 8 }) => {
  let queryParams = [];

  if (exclude.length) {
    queryParams.push(`exclude=${exclude.join(",")}`);
  }
  if (size >= 0) {
    queryParams.push(`size=${size}`);
  }

  if (queryParams.length) {
    queryParams = `?${queryParams.join("&")}`;
  } else {
    queryParams = "";
  }

  const response = await apiFetch({
    endpoint: `news-and-events/${page}/${queryParams}`,
    method: "GET",
    headers: {},
  });

  return await response.json();
};
